<template>
    <div class="DialogTip" v-if="isShow">
        <div class="dialog">
            <div class="dialogText">
                <h2>{{text.mesg}}</h2>
                <!-- <p>{{text.mesg}}</p> -->
            </div>
            <el-button type="primary" class="dialogBtn" @click="cancel">OK</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: "DialogTip",
    data() {
        return {
            text: {
                title: '',
                mesg: ''
            },
            isShow: true
        }
    },
    methods: {
        cancel() {
            this.isShow = false
        }
    }
}
</script>
<style lang="scss" scoped>
.DialogTip {
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.40);
    z-index: 3000;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    .dialog {
        width: 480px;
        padding: 48px 20px;
        box-sizing: border-box;
        box-shadow: 0px 3px 8px #00000014;
        border-radius: 16px;
        overflow: hidden;
        text-align: center;
        background: #FFFFFF;
        margin: -53px auto 0;
        .dialogText{
            padding-bottom: 48px;
            h2 {
                margin: 0;
                font: normal normal bold 20px/26px Nunito;
                letter-spacing: 0px;
                color: #2E2E2E;
            }
            p {
                margin-top: 4px;
                font: normal normal normal 13px/16px Nunito;
                letter-spacing: 0px;
                color: #2E2E2E;
            }
        }
        .dialogBtn {
            width: 320px;
            height: 48px;
            border-radius: 8px;
            text-align: center;
            font: normal normal bold 16px/24px Nunito;
            letter-spacing: 0px;
            color: #FFFFFF;
        }
    }
}
</style>